import * as Yup from "yup";

export const accessoriesSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required"),
  Price: Yup.number().typeError("Price must be a number").required("Price is required"),
  image: Yup.string().url("Image must be a valid URL").required("Image URL is required"),
 
});
